<template>
  <div class="form-group d-flex flex-wrap col-12 mb-16">
    <div class="col-12">
      <label class="form-label">IBAN *</label>
      <div id="iban" class="form-control"></div>
    </div>

    <div id="stripe-element-form--errors"
         class="error"
         role="alert"
         ref="errors"></div>

    <div id="mandate-acceptance" class="text-xs mt-16" v-if="sepaText">
      {{ sepaText }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'StripePaymentSepaMethod',
  props: {
    trans: {
      required: true,
    },
    country: {
      required: true,
    },
    stripe: {
      required: true,
      type: Object,
    },
    sepaText: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      iban: '',
    }
  },
  async mounted() {
    let elements = this.stripe.elements();

    let elementClasses = {
      focus: 'focus',
      empty: 'empty',
      invalid: 'is-invalid',
    };

    let elementStyles = {
      base: {
        color: '#FFFFFF',
        fontWeight: 500,
        fontSize: '16px',
        fontSmoothing: 'antialiased',
        '::placeholder': {
          color: 'rgba(255, 255, 255, 0.3)',
        },
      },
      invalid: {
        color: '#F32859',
      },
    };

    this.iban = elements.create('iban', {
      style: elementStyles,
      classes: elementClasses,
      supportedCountries: ['SEPA'],
      placeholderCountry: this.country,
    });

    this.iban.mount('#iban');

    this.registerElements([this.iban]);
  },
  methods: {
    registerElements: function (elements) {
      this.$emit('registerElements', elements);
    },
    async createIbanSource(client_name, client_email) {
      return await this.stripe.createSource(this.iban, {
        type: 'sepa_debit',
        currency: 'eur',
        owner: {
          name: client_name,
          email: client_email,
        },
      });
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
